import Vue from 'vue'
import MastHead from '@rhitics/vue/components/MastHead.vue'

export default Vue.extend({
  name: 'AccessDenied',

  components: {
    MastHead
  },

  data() {
    return {
      role: '',
      ability: ''
    }
  },

  created() {
    const query = this.$route.query
    const role = query.role as string
    const ability = query.ability as string
    this.role = role || ''
    this.ability = ability || ''
  },

  computed: {
    message(): string {
      if (!this.role && !this.ability) {
        return 'Sorry, you can\'t access.'
      }

      let message = 'Please make sure you these role or ability. \n'

      if (this.role) {
        message += 'Role: ' + this.role + '\n'
      }

      if (this.ability) {
        message += 'Ability: ' + this.ability
      }

      return message
    }
  },

  render() {
    return (
      <v-app>
        <mast-head />
        <v-content>
          <v-container>
            <v-row>
              <v-col xs="12" offset-sm="2" sm="8" offset-md="4" md="4">
                <v-alert border="right" colored-border type="error" elevation="2" style="margin-top: 150px">
                  <div class="headline">Access Denied.</div>
                  <div>{this.message}</div>
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
          <router-view />
        </v-content>
      </v-app>
    )
  }
})
